import React from 'react';
import styles from '../../styles/AdmisionEstudiantesStyles/AdmisionEstudiantes.module.css';

function ViewStudentModal({ student, onClose }) {
  const formatDate = (dateStr) => {
    if (!dateStr) return 'No especificado';
    const date = new Date(dateStr);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const getStatusLabel = (estatus) => {
    switch (estatus) {
      case 'ACTIVO': return 'Activo';
      case 'BAJA_TEMPORAL': return 'Baja Temporal';
      case 'BAJA_DEFINITIVA': return 'Baja Definitiva';
      case 'EGRESADO': return 'Egresado';
      case 'GRADUADO': return 'Egresado'; // Compatibilidad con datos antiguos
      case 'NO_INSCRITO': return 'No inscrito';
      case 'PASANTE': return 'Pasante';
      default: return estatus || 'No especificado';
    }
  };

  const getSexoLabel = (sexo) => {
    switch (sexo) {
      case 'M': return 'Masculino';
      case 'F': return 'Femenino';
      case 'O': return 'Otro';
      default: return sexo || 'No especificado';
    }
  };

  const getTipoIngresoLabel = (tipo) => {
    switch (tipo) {
      case 'NUEVO': return 'Nuevo Ingreso';
      case 'REINGRESO': return 'Reingreso';
      case 'TRANSFERENCIA': return 'Transferencia';
      default: return tipo || 'No especificado';
    }
  };

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modal}>
        <div className={styles.modalHeader}>
          <h2 className={styles.modalTitle}>Ver Estudiante</h2>
          <button className={styles.closeButton} onClick={onClose}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <line x1="18" y1="6" x2="6" y2="18"/>
              <line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        </div>
        
        <div className={styles.modalContent} style={{ maxHeight: '70vh', overflowY: 'auto' }}>
          <div className={styles.tabContent}>
            <h3 style={{ marginBottom: '20px', color: '#333', fontSize: '18px' }}>Datos Personales</h3>
            
            <div className={styles.formRow}>
              <div className={styles.formGroup}>
                <label className={styles.formLabel}>Nombre Completo</label>
                <div className={styles.viewField}>{student.nombre_completo || 'No especificado'}</div>
              </div>
            </div>
            
            <div className={styles.formRow}>
              <div className={styles.formGroup}>
                <label className={styles.formLabel}>Institución</label>
                <div className={styles.viewField}>{student.institucion_nombre || 'No especificado'}</div>
              </div>
              <div className={styles.formGroup}>
                <label className={styles.formLabel}>Campus</label>
                <div className={styles.viewField}>{student.campus_nombre || 'No especificado'}</div>
              </div>
            </div>
            
            <div className={styles.formRow}>
              <div className={styles.formGroup}>
                <label className={styles.formLabel}>Matrícula</label>
                <div className={styles.viewField}>{student.matricula || 'No especificado'}</div>
              </div>
              <div className={styles.formGroup}>
                <label className={styles.formLabel}>CURP</label>
                <div className={styles.viewField}>{student.curp || 'No especificado'}</div>
              </div>
            </div>
            
            <div className={styles.formRow}>
              <div className={styles.formGroup}>
                <label className={styles.formLabel}>Fecha de Nacimiento</label>
                <div className={styles.viewField}>{formatDate(student.fecha_nacimiento)}</div>
              </div>
              <div className={styles.formGroup}>
                <label className={styles.formLabel}>Lugar de Nacimiento</label>
                <div className={styles.viewField}>{student.lugar_nacimiento || 'No especificado'}</div>
              </div>
            </div>
            
            <div className={styles.formRow}>
              <div className={styles.formGroup}>
                <label className={styles.formLabel}>Género</label>
                <div className={styles.viewField}>{getSexoLabel(student.sexo)}</div>
              </div>
              <div className={styles.formGroup}>
                <label className={styles.formLabel}>Estado Civil</label>
                <div className={styles.viewField}>{student.estado_civil || 'No especificado'}</div>
              </div>
            </div>
            
            <div className={styles.formRow}>
              <div className={styles.formGroup}>
                <label className={styles.formLabel}>Nacionalidad</label>
                <div className={styles.viewField}>{student.nacionalidad || 'No especificado'}</div>
              </div>
              <div className={styles.formGroup}>
                <label className={styles.formLabel}>País de Origen</label>
                <div className={styles.viewField}>{student.pais_origen || 'No especificado'}</div>
              </div>
            </div>
            
            <div className={styles.formRow}>
              <div className={styles.formGroup}>
                <label className={styles.formLabel}>Email Personal</label>
                <div className={styles.viewField}>{student.email_personal || 'No especificado'}</div>
              </div>
              <div className={styles.formGroup}>
                <label className={styles.formLabel}>Email Institucional</label>
                <div className={styles.viewField}>{student.email_institucional || 'No especificado'}</div>
              </div>
            </div>
            
            <div className={styles.formRow}>
              <div className={styles.formGroup}>
                <label className={styles.formLabel}>Teléfono Principal</label>
                <div className={styles.viewField}>{student.telefono_principal || 'No especificado'}</div>
              </div>
              <div className={styles.formGroup}>
                <label className={styles.formLabel}>Teléfono de Emergencia</label>
                <div className={styles.viewField}>{student.telefono_emergencia || 'No especificado'}</div>
              </div>
            </div>
            
            <div className={styles.formRow}>
              <div className={styles.formGroup}>
                <label className={styles.formLabel}>Contacto de Emergencia</label>
                <div className={styles.viewField}>{student.contacto_emergencia || 'No especificado'}</div>
              </div>
              <div className={styles.formGroup}>
                <label className={styles.formLabel}>Estatus del Estudiante</label>
                <div className={styles.viewField}>{getStatusLabel(student.estatus_estudiante)}</div>
              </div>
            </div>

            <h3 style={{ marginTop: '30px', marginBottom: '20px', color: '#333', fontSize: '18px' }}>Domicilio</h3>
            
            <div className={styles.formRow}>
              <div className={styles.formGroup}>
                <label className={styles.formLabel}>Calle y Número</label>
                <div className={styles.viewField}>{student.calle || 'No especificado'}</div>
              </div>
              <div className={styles.formGroup}>
                <label className={styles.formLabel}>Colonia</label>
                <div className={styles.viewField}>{student.colonia || 'No especificado'}</div>
              </div>
            </div>
            
            <div className={styles.formRow}>
              <div className={styles.formGroup}>
                <label className={styles.formLabel}>Ciudad</label>
                <div className={styles.viewField}>{student.ciudad || 'No especificado'}</div>
              </div>
              <div className={styles.formGroup}>
                <label className={styles.formLabel}>Estado</label>
                <div className={styles.viewField}>{student.estado || 'No especificado'}</div>
              </div>
            </div>
            
            <div className={styles.formRow}>
              <div className={styles.formGroup}>
                <label className={styles.formLabel}>Código Postal</label>
                <div className={styles.viewField}>{student.codigo_postal || 'No especificado'}</div>
              </div>
              <div className={styles.formGroup}>
                <label className={styles.formLabel}>País</label>
                <div className={styles.viewField}>{student.pais || 'No especificado'}</div>
              </div>
            </div>

            <h3 style={{ marginTop: '30px', marginBottom: '20px', color: '#333', fontSize: '18px' }}>Información Académica</h3>
            
            <div className={styles.formRow}>
              <div className={styles.formGroup}>
                <label className={styles.formLabel}>Programa</label>
                <div className={styles.viewField}>{student.programa_nombre || 'No especificado'}</div>
              </div>
              <div className={styles.formGroup}>
                <label className={styles.formLabel}>Ciclo Escolar de Ingreso</label>
                <div className={styles.viewField}>{student.ciclo_escolar_nombre || 'No especificado'}</div>
              </div>
            </div>
            
            <div className={styles.formRow}>
              <div className={styles.formGroup}>
                <label className={styles.formLabel}>Período Inicial</label>
                <div className={styles.viewField}>{student.periodo_inicial || 'No especificado'}</div>
              </div>
              <div className={styles.formGroup}>
                <label className={styles.formLabel}>Institución de Procedencia</label>
                <div className={styles.viewField}>{student.institucion_procedencia || 'No especificado'}</div>
              </div>
            </div>
            
            <div className={styles.formRow}>
              <div className={styles.formGroup}>
                <label className={styles.formLabel}>Promedio de Procedencia</label>
                <div className={styles.viewField}>{student.promedio_procedencia || 'No especificado'}</div>
              </div>
              <div className={styles.formGroup}>
                <label className={styles.formLabel}>Tipo de Ingreso</label>
                <div className={styles.viewField}>{getTipoIngresoLabel(student.tipo_ingreso)}</div>
              </div>
            </div>
          </div>
        </div>
        
        <div className={styles.modalActions}>
          <div className={styles.modalActionsRight}>
            <button type="button" className={styles.cancelButton} onClick={onClose}>
              CERRAR
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ViewStudentModal;
